import React from 'react';
import { GoogleApiWrapper } from 'google-maps-react';
import $ from 'jquery';
import Config from './../../../../../constants/Config';
import Input from './../Input';
import './styles.less';
class AddressInput extends React.Component {

    state = {
        inputValue: '',
    }

    render() {
        return (
            <div className="hms-address-input">
                <Input id="hms-place-input" value={this.state.inputValue} onChange={this.onInputChange} placeholder={''}>{this.props.children}</Input>
            </div>
        )
    }

    componentDidMount() {
        this.setState({ inputValue: this.props.value });
        this.autocomplete = new window.google.maps.places.Autocomplete($('.hms-address-input > #hms-place-input')[0], {});
        this.autocomplete.addListener('place_changed', this.onPlaceChange);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.value !== this.props.value) {
            this.setState({ inputValue: this.props.value })
        }
    }

    onInputChange = (e) => {
        const inputValue = e.target.value;
        this.setState({ inputValue });
        return this.props.onChange && this.props.onChange(e);
    }

    onPlaceChange = () => {
        const place = this.autocomplete.getPlace();
        if (!place) return;
        const address = place.formatted_address || this.state.inputValue;
        const result = { address };
        if (!place.geometry) return;
        const lat = place.geometry.location.lat()
        const lng = place.geometry.location.lng()
        if (lat && lng) {
            result.lat = lat;
            result.lng = lng;
        }
        result.place = place;
        this.setState({ inputValue: address })
        this.props.onSelect && this.props.onSelect(result)
    }
}
export default GoogleApiWrapper({
    apiKey: Config.GOOGLE_MAPS_API_KEY
})(AddressInput);